import React from 'react';
import { Icon } from './Icon.js';
export const IconCircleArrowDown2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 7L12 16L12 15.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 18L7.5 12L16.5 12L12 18Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCircleArrowDown2.js.map